var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.913 5.21739H18.6052L16.6957 3.13043H10.4348V5.21739H15.7774L17.687 7.30435H21.913V19.8261H5.21739V10.4348H3.13043V19.8261C3.13043 20.9739 4.06957 21.913 5.21739 21.913H21.913C23.0609 21.913 24 20.9739 24 19.8261V7.30435C24 6.15652 23.0609 5.21739 21.913 5.21739ZM8.34783 13.5652C8.34783 16.4452 10.6852 18.7826 13.5652 18.7826C16.4452 18.7826 18.7826 16.4452 18.7826 13.5652C18.7826 10.6852 16.4452 8.34783 13.5652 8.34783C10.6852 8.34783 8.34783 10.6852 8.34783 13.5652ZM13.5652 10.4348C15.287 10.4348 16.6957 11.8435 16.6957 13.5652C16.6957 15.287 15.287 16.6957 13.5652 16.6957C11.8435 16.6957 10.4348 15.287 10.4348 13.5652C10.4348 11.8435 11.8435 10.4348 13.5652 10.4348ZM5.21739 5.21739H8.34783V3.13043H5.21739V0H3.13043V3.13043H0V5.21739H3.13043V8.34783H5.21739V5.21739Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.75683c42e197d351ab145eaf0b717924.svg";
export { ForwardRef as ReactComponent };